import React from "react";

type SupportBlockProps = {
  tailwindProps?: string,
  area?: string | null
}

/**
 * Support email prompt used under SSO forms.
 * @param {SupportBlockProps} props
 */
const SupportBlock = ({ tailwindProps="", area=null }: SupportBlockProps) => {
  return (
    <div className={tailwindProps || "mt-8"}>
      <p className="text-center mb-0 text-xs leading-5 text-slate-500 font-poppins">
        Have you encountered an issue? Contact us{' '}
        <a
          href={`mailto:support@tripplo.freshdesk.com?subject=Tripplo SSO - Unexpected issue encountered ${area ? "[" + area + "]" : ""}`}
          className="text-[#0458f6] font-medium hover:underline"
        >here</a>
      </p>
    </div>
  )
}

export default SupportBlock
